import React from 'react';
import { Dropdown } from 'react-bootstrap';
import {
    getWhatsAppAppUrl,
    getWhatsAppWebUrl,
    getServiceBadgeClass
} from '../EnquiryList/enquiryUtils';
import { MeetingSchoolCell } from './MeetingSchoolCell';
import { MeetingUserCell } from './MeetingUserCell';
import { MeetingDetailsCell } from './MeetingDetailsCell';
import { MeetingMobileCard } from './MeetingMobileCard';
import { MeetingWhatsAppModal } from './MeetingWhatsAppModal';
import { FollowUpHistoryModal } from '../FollowUpHistoryModal';
import { FollowUpBtn } from '../FollowUpBtn';

export const getMeetingArrangeColumns = ({ handleReport, handleFollowSuccess }) => [
    {
        Header: 'School Details',
        accessor: 'enquiry.name',
        HeaderClass: 'text-start',
        DataClass: 'text-start align-middle',
        Cell: (cell) => (
            <MeetingSchoolCell row={cell.row.original} handleReport={handleReport} />
        )
    },
    {
        Header: 'Phone / Principal',
        accessor: 'enquiry.phone',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => {
            const enq = cell.row.original.enquiry || {};
            return (
                <div>
                    {enq.father_name && (
                        <span className="fw-semibold text-dark fs-12 d-block text-truncate" title={`Principal: ${enq.father_name}`}>
                            <i className="ri-user-star-line text-muted me-1" />
                            {enq.father_name}
                        </span>
                    )}
                    <a
                        href={`tel:${enq.phone}`}
                        className="text-success fw-medium text-decoration-none d-inline-flex align-items-center fs-13 mt-0.5"
                    >
                        <i className="bx bx-phone me-1 text-success fs-14" />
                        {enq.phone || 'N/A'}
                    </a>
                </div>
            );
        }
    },
    {
        Header: 'Followed By (Staff)',
        accessor: 'callerUser.first_name',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => <MeetingUserCell row={cell.row.original} />
    },
    {
        Header: 'Meeting Date & Agenda',
        accessor: 'meetingDate',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => <MeetingDetailsCell row={cell.row.original} />
    },
    {
        Header: 'Service',
        accessor: 'enquiry.course.name',
        HeaderClass: 'text-center',
        DataClass: 'text-center align-middle',
        Cell: (cell) => {
            const serviceName = cell.row.original.enquiry?.course?.name || cell.value;
            const badgeClass = getServiceBadgeClass(serviceName);
            return (
                <span className={`service-pill-badge ${badgeClass}`}>
                    {serviceName || 'N/A'}
                </span>
            );
        }
    },
    {
        Header: 'Action',
        HeaderClass: 'text-center',
        DataClass: 'text-center align-middle',
        Cell: (cell) => {
            const row = cell.row.original;
            const enq = row.enquiry || {};

            return (
                <div className="d-flex align-items-center justify-content-center gap-1">
                    {/* WhatsApp Meeting Modal Trigger */}
                    <MeetingWhatsAppModal row={row}>
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-success py-1 px-2 border-0 d-inline-flex align-items-center"
                            title="Send Meeting Link on WhatsApp"
                        >
                            <i className="ri-whatsapp-line fs-14 text-success" />
                        </button>
                    </MeetingWhatsAppModal>

                    {/* All Call & SMS History */}
                    <FollowUpHistoryModal enquiryId={enq.id} schoolName={enq.name}>
                        <button className="btn btn-sm btn-soft-primary py-1 px-2" title="All Call & SMS History">
                            <i className="ri-chat-3-line fs-13" />
                        </button>
                    </FollowUpHistoryModal>

                    {/* Follow Up Modal Button to record next follow-up or update status */}
                    <FollowUpBtn follow={row} onSuccess={handleFollowSuccess} />

                    {/* Complete Report Button */}
                    <button
                        type="button"
                        className="btn btn-sm btn-soft-secondary py-1 px-2"
                        title="View Full History Report"
                        onClick={() => handleReport && handleReport(row)}
                    >
                        <i className="ri-file-list-3-line fs-13" />
                    </button>
                </div>
            );
        }
    },
    {
        Header: 'List',
        HeaderClass: 'd-none',
        DataClass: 'd-none',
        listClass: 'list-group-item border-0 px-0 bg-transparent',
        list: (row) => (
            <MeetingMobileCard
                row={row}
                handleReport={handleReport}
                handleFollowSuccess={handleFollowSuccess}
            />
        )
    }
];

export default getMeetingArrangeColumns;
